import { Injectable } from '@angular/core';
import { environment as config } from '../../../environments/environment';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { BasicService } from '../../providers/basic';
import { IPlugin } from '../../models/plugin';
import { ISession } from '../../models/session';
import { Subject } from 'rxjs/Subject';

const API = config.plugins.url;

@Injectable()
export class PluginsService extends BasicService {
  constructor(
    protected auth: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp
  ) {
    super(auth, translate);
  }

  public onPluginsStateChange$: Subject<IPlugin[]> = new Subject();

  public getAll = (session: ISession) => {
    return this.http
      .get(`${API}/sessions/${session.id}/plugins?language=${session.language}`)
      .map(response => response.json())
      .do(plugins => {
        this.onPluginsStateChange$.next(plugins);
      })
      .catch(err => this.handleError(err));
  };

  public togglePlugin(plugin: IPlugin, session: ISession, state: boolean) {
    const payload = {
      pluginName: plugin.name,
      sessionId: session.id,
      isActivated: state
    };
    return this.http
      .put(`${API}/sessions/${session.id}/plugins/toggle?language=${session.language}`, payload)
      .map(response => response.json())
      .do(() => {
        this.getAll(session).subscribe();
      })
      .catch(err => this.handleError(err));
  }

  public toggleOnly(session: ISession, data: any) {
    const payload = {
      pluginName: data.pluginName,
      sessionId: session.id
    };
    return this.http
      .put(`${API}/sessions/${session.id}/plugins/toggleOnly?language=${session.language}`, payload)
      .map(response => response.json())
      .do(() => {
        this.getAll(session).subscribe();
      })
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/plugins/plugins.service.ts